import api from './config/api';
import axios from './config/axios';

export default {
    /**
     * @GET
     * Get a customer csv export
     */
    getCustomerFileExport( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/export/customers/csv` ),
            method: 'get',
            headers: {
                ...api.authHeaders( jwtToken ),
                Accept: 'application/octet-stream',
            },
        } );
    },

    /**
     * @POST
     * Post a CSV file of customers to be imported
     * @param jwtToken
     * @param websiteId
     * @param userAccountId
     * @param file
     */
    postCustomerCsvImport( {
        jwtToken,
        websiteId,
        userAccountId,
        file,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/import/customers/csv` ),
            method: 'post',
            headers: {
                ...api.authHeaders( jwtToken ),
                'Content-Type': 'text/csv',
            },
            data: file,
        } );
    },

    /**
     * Validate a customer csv file
     * @POST
     * @param jwtToken
     * @param websiteId
     * @param userAccountId
     * @param file
     */
    validateCustomerCsv( {
        jwtToken,
        websiteId,
        userAccountId,
        file,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/validate/customers/csv` ),
            method: 'post',
            headers: {
                ...api.authHeaders( jwtToken ),
                'Content-Type': 'text/csv',
            },
            data: file,
        } );
    },
};
